import React from 'react';
import { Activity, X } from 'lucide-react';

interface Event {
    id: number;
    type: 'action' | 'scan';
    text: string;
    status: string;
    timestamp: string;
    time: string;
}

interface LogicDetailModalProps {
    event: Event;
    onClose: () => void;
}

const LogicDetailModal = ({ event, onClose }: LogicDetailModalProps) => (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/50 backdrop-blur-md animate-fade-in">
        <div role="dialog" aria-modal="true" aria-label="Detalle del evento" className="bg-white border border-slate-200 w-full max-w-lg rounded-2xl shadow-2xl relative overflow-hidden flex flex-col max-h-[90vh]">
            <div className="p-5 border-b border-slate-100 bg-slate-50 flex justify-between items-center">
                <h2 className="text-lg font-bold text-slate-900 flex items-center gap-2">
                    <Activity size={18} className="text-violet-600" /> Detalle del Evento
                </h2>
                <button
                    onClick={onClose}
                    className="p-2 hover:bg-slate-200 rounded-lg text-slate-500 hover:text-slate-800 transition-colors"
                >
                    <X size={18} />
                </button>
            </div>
            <div className="p-6 space-y-4 overflow-y-auto">
                <div className="bg-slate-50 p-4 rounded-xl border border-slate-100">
                    <div className="text-[10px] text-slate-500 uppercase font-bold mb-1 tracking-wider">Tipo de Evento</div>
                    <div className="text-slate-900 font-medium capitalize flex items-center gap-2">
                        <div className={`w-2 h-2 rounded-full ${event.type === 'action' ? 'bg-violet-500' : 'bg-blue-400'}`}></div>
                        {event.type}
                    </div>
                </div>
                <div className="bg-slate-50 p-4 rounded-xl border border-slate-100">
                    <div className="text-[10px] text-slate-500 uppercase font-bold mb-1 tracking-wider">Descripción</div>
                    <div className="text-slate-900 font-medium text-sm leading-relaxed">{event.text}</div>
                </div>
                <div className="bg-slate-50 p-4 rounded-xl border border-slate-100">
                    <div className="text-[10px] text-slate-500 uppercase font-bold mb-1 tracking-wider">Timestamp</div>
                    <div className="text-slate-700 font-mono text-xs">{event.timestamp}</div>
                </div>

                {/* Mock Logic Trace */}
                <div className="bg-slate-900 p-4 rounded-xl border border-slate-800 font-mono text-xs text-slate-300">
                    <div className="text-slate-500 mb-2 border-b border-slate-800 pb-2">LOGIC TRACE_ID: {event.id}</div>
                    <div className="space-y-1">
                        <div>{`> Processing Event...`}</div>
                        <div>{`> Context: { wallet: ${Math.random() > 0.5 ? 'Active' : 'Dormant'} }`}</div>
                        <div className="text-green-400">{`> Decision: ${event.type === 'action' ? 'EXECUTE' : 'SKIP'}`}</div>
                        <div className="text-violet-400">{`> Latency: ${Math.floor(Math.random() * 50)}ms`}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
);

export default LogicDetailModal;
